import { Pipe, PipeTransform } from '@angular/core';
import { ALL } from '../constants/constants';

@Pipe({
  name: 'filterAll',
  standalone: true
})
export class FilterAllPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return items.filter(item => 
      item.name !== ALL && 
      item.name !== 'Other' && 
      item.isFilter && 
      !item.isOther
    );
  }
}